import { env } from 'utils/envManager'

export const NOTIFICATION_KEY = 'mango-likes-you.tier'

export const GET_NOTIFICATIONS_URL = `${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-customer-notifications/v1/account/{accountid}/type/${NOTIFICATION_KEY}`
